import { PlayfulThemeId } from '../identifiers';
import { PlayfulThemeDefinition } from '../types';
import { IconName } from '@/icons/types';
import { SpaceMascot } from '@/components/core/ThemeMascot/mascots';

export const spaceTheme: PlayfulThemeDefinition = {
  id: PlayfulThemeId.SPACE,
  hover: {
    transform: 'translateY(-6px) rotate(1deg)',
    transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  click: {
    transform: 'scale(0.95)',
    transition: 'transform 0.15s ease-out',
  },
  idle: {
    animationName: 'playful-space-float',
    animationDuration: '4s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite',
  },
  dragStart: {
    transform: 'scale(1.05) rotate(-2deg)',
    transition: 'transform 0.2s ease-out',
  },
  particles: {
    enabled: true,
    count: 8,
    characters: ['⭐', '✨', '🌟', '💫'],
    spread: 60,
    duration: 1200,
    size: 16,
  },
  keyframes: [
    {
      name: 'playful-space-float',
      css: `@keyframes playful-space-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-3px) rotate(0.5deg); }
  75% { transform: translateY(3px) rotate(-0.5deg); }
}`,
    },
  ],
  sounds: {
    hover: { name: 'ui/pop_open', volume: 0.15, rate: 1.3 },
    click: { name: 'arcade/coin', volume: 0.25 },
  },
  metadata: {
    label: 'Space',
    icon: IconName.SPARKLES,
    previewEmoji: '🚀',
    description: 'Floaty cosmic vibes',
    mascotEmoji: '🚀',
    mascotComponent: SpaceMascot,
  },
};
